module.exports = __webpack_public_path__ + "img/8-1_Assign_Factor.79ce7a9c.png";